import { render, staticRenderFns } from "./BookmakerStackerTile.vue?vue&type=template&id=3bf67b6e"
import script from "./BookmakerStackerTile.vue?vue&type=script&lang=js"
export * from "./BookmakerStackerTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports